import Vue from 'vue';
import Router from 'vue-router';
import ProductList from './components/ProductList.vue';
import New from './new.vue';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/index' // 访问 / 时自动重定向到 /index
        },
        {
            path: '/news',
            name: 'News',
            component: () => import('@/new.vue')
        },
        {
            path: '/index',
            name: 'Index',
            component: () => import('@/index.vue')
        },
        {
            path: '/join',
            name: 'Join',
            component: () => import('@/join.vue')
        },
        {
            path: '/ContactUs',
            name: 'ContactUs',
            component: () => import('@/ContactUs.vue')
        },
        {
            path: '/shouhou',
            name: 'Shouhou',
            component: () => import('@/shouhou.vue')
        },
        {
            path: '/xiaoshou',
            name: 'Xiaoshou',
            component: () => import('@/xiaoshou.vue')
        },
        {
            path: '/productInfo',
            name: 'ProductInfo',
            component: () => import('@/productInfo.vue')
        },
        {
            path: '/productSearch',
            name: 'ProductSearch',
            component: () => import('@/productSearch.vue')
        },
        {
            path: '/newsInfo',
            name: 'NewsInfo',
            component: () => import('@/newsInfo.vue')
        },
        {
            path: '/rwachaxun',
            name: 'Rwachaxun',
            component: () => import('@/rwachaxun.vue')
        }
    ]
});
